export default {
  index: [
    {
      path: '/riskmanage',
      component: resolve => require(['./riskmanageIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/riskmanage/_router.js